import * as Styled from '@/components/shared/logs-explorer/components/styles'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

const MESSAGE_WIDTHS = [
  'w-[72%]',
  'w-[45%]',
  'w-[88%]',
  'w-[33%]',
  'w-[61%]',
  'w-[54%]',
  'w-[79%]',
  'w-[42%]',
  'w-[67%]',
  'w-[38%]',
  'w-[83%]',
  'w-[28%]',
  'w-[56%]',
  'w-[74%]',
  'w-[47%]',
  'w-[65%]',
  'w-[36%]',
  'w-[91%]',
  'w-[52%]',
  'w-[78%]',
  'w-[41%]',
  'w-[69%]',
  'w-[85%]',
  'w-[31%]',
  'w-[58%]',
  'w-[76%]',
  'w-[44%]',
  'w-[63%]',
  'w-[39%]',
  'w-[82%]',
  'w-[50%]',
  'w-[71%]',
  'w-[34%]',
  'w-[87%]',
  'w-[46%]',
  'w-[59%]',
  'w-[75%]',
  'w-[29%]',
  'w-[66%]',
  'w-[53%]',
]

export const LogLinesSkeleton = () => (
  <div className="h-full overflow-hidden">
    {MESSAGE_WIDTHS.map((width, index) => (
      <Styled.LogRowContent key={index}>
        <Styled.ConsoleContent>
          <div className="flex gap-2 flex-nowrap items-center min-h-6 w-full">
            <Skeleton className="w-1 h-5 shrink-0 rounded-full" />
            <Skeleton className="h-3 w-[108px] shrink-0" />
            <Skeleton className={cn('h-3', 'shrink-0', width)} />
          </div>
        </Styled.ConsoleContent>
      </Styled.LogRowContent>
    ))}
  </div>
)
